<template>
  <div style="height: 100%" class="bom">
    <SplitContainer3 style="height:100%" :layout="12" :split_setting1="0.4">
      <template #main>
        <TableMain name="one table" ref="CostCaclTable1" :fields="fields1" title="quote_apply_detail"
          :date_picker_label="''" :query_button_label="query_lable" :show_query_container="true"
          :show_toolbar_container="true" :show_pagination_container="true" :show_date_picker="false" :show_toolbar="false"
          :show_filter="true" :isBusy="isBusy" :show_query_button="false" :table_height_adjust="-6"
          :show_toolbar_button="[0, 0, 0, 0, 0]" :loading_width="60" :hb_table_class="'hb_table_costcaclsearch_class1'"
          @on_query="on_query" @current_changed="current_changed" tableref="736db0ca5fe0404caf54a630f2b061f3">
          <template #query>
            <el-form ref="dataForm" label-width="120px" class="mt-1 pl-4">
              <el-col :span="24">
                <el-form-item label="报价申请编号：" class="mb-0">
                  <el-select size="mini" v-model="QuotationTaskNum" filterable remote reserve-keyword
                    :remote-method="QTRemoteMethod" clearable @clear="QTRemoteMethod('')" @focus="QTRemoteMethod('')"
                    placeholder="请输入报价申请编号关键词" style="width:200px">
                    <el-option v-for="(t, k) in QTOptions" :key="k" :label="t.label" :value="t.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="客户名称：" class="mb-0">
                  <el-input placeholder="请输入客户名称" v-model="CustName" style="width:200px" clearable
                    class="mr-1"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="物料编号：" class="mb-0">
                  <el-input placeholder="请输入物料编号" v-model="ItemId" style="width:200px" clearable class="mr-1"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="物料名称：" class="mb-0">
                  <el-input placeholder="请输入物料名称" v-model="NameAlias" style="width:200px" clearable
                    @input="onInput()"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24" style="float:right">
                <el-form-item class="mb-0">
                  <el-button type="primary" @click="on_query"><i
                      class="iconfont icon-search"></i>&nbsp;&nbsp;{{ $t('common.query') }}
                  </el-button>
                </el-form-item>
              </el-col>
            </el-form>
          </template>
        </TableMain>
      </template>
      <template #top>
        <TableMain ref="CostCaclTable2" :fields="detail_cost_fields" :show_query_container="false"
          :title="'cost_manufacturer'" :show_toolbar="false" :date_picker_label="''" :table_height_adjust="8"
          :check_state="true" :show_pagination="true" :show_filter="false" :pager_count="5" :isBusy="isBusy2"
          :show_toolbar_button="[0, 0, 0, 0, 0]" @on_cell_button_click="on_cell_button_click" tableref="43dcfaa7eb1b47fa8f3c270413b75277">
        </TableMain>
      </template>
      <template #bottom>
        <TableMain ref="CostCaclTable3" :fields="detail_vend_price_fields" :show_query_container="false"
          :title="'quote_vend'" :show_toolbar="false" :date_picker_label="''" :table_height_adjust="2" :check_state="true"
          :show_pagination="true" :show_filter="false" :pager_count="5" :isBusy="isBusy3"
          :show_toolbar_button="[0, 0, 0, 0, 0]" tableref="d49d7ae25b5d402881f699779a31e688">
        </TableMain>
      </template>
    </SplitContainer3>
    <el-drawer :size="'70%'" :visible.sync="isShowDrawer" :direction="'rtl'" :modal="false">
      <template slot="title">
        <span>{{ DrawerTitle }}</span>
      </template>
      <CostTree :data1="treeData1" :data2="treeData2" :data3="treeData3" :total_cost="total_cost"
        :cur_product_qty="cur_product_qty" :dataAreaId="dataAreaId"></CostTree>
    </el-drawer>
    <el-dialog :title="dialogTableTitle" :visible.sync="dialogTableVisible">
      <el-table ref="TransportDetailContent" :data="TransportCostJson" style="width: 100%;border:1px solid gainsboro">
        <el-table-column prop="AccountNum" label="供应商编号" width="120">
        </el-table-column>
        <el-table-column prop="AccountName" label="供应商名称">
        </el-table-column>
        <el-table-column prop="CostName" label="成本类别" width="80">
        </el-table-column>
        <el-table-column prop="TransportCost" label="成本" width="80">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import * as CostItemsController from "../../controllers/sd/CostItemsController";
import * as QuotationTaskController from "../../controllers/sd/QuotationTaskController";
import * as VendInitialQuoteController from "../../controllers/sd/VendInitialQuoteController";
import QueryButton from "../components/base/QueryButton";
import SplitContainer3 from "../components/container/SplitContainer3";
import TableMain from "../components/table/TableMain";
import CostTree from "./CostTree.vue";
export default {
  components: {
    SplitContainer3,
    TableMain,
    QueryButton,
    CostTree
  },
  data() {
    return {
      date_picker_label: "",
      query_lable: this.$t("common.query"),
      fields1: _.cloneDeep(CostItemsController.fields.qt_detail),
      detail_cost_fields: _.cloneDeep(CostItemsController.fields.detail_cost_fields),
      detail_vend_price_fields: CostItemsController.fields.detail_vend_price_fields,
      QuotationTaskNum: "",
      CustName: "",
      ItemId: "",
      NameAlias: "",
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      activeCode: "bomcost",
      isBusy: false,
      isBusy2: false,
      isBusy3: false,
      total_cost: 0,
      cur_product_qty: 1,
      DrawerTitle: "",
      isShowDrawer: false,
      dataAreaId: "",
      treeData1: [],
      treeData2: [],
      treeData3: [],
      QTOptions: [],
      TransportCostJsonHis: [],
      TransportCostJson: [],
      dialogTableVisible: false,
      dialogTableTitle: ""
    }
  },
  created() {
    let _TransportCost = _.find(this.detail_cost_fields, { key: "TransportCost" });
    if (_TransportCost) {
      _TransportCost.type = "button"
    }

  },
  async mounted() {
  },
  methods: {
    ///获取报价申请编号
    async getKvQuoteTask(query = '') {
      let p = { is_deleted: { "=": 0 } }
      p.QuotationTaskNum = { like: "%" + query + "%" }
      let _result = await QuotationTaskController.methods.getData(p, "kv");
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.map(_.filter(_result[0], { fcCheckSQOApproved: true }), (t) => {
          return { value: t.QuotationTaskNum, label: t.dataAreaId + ":" + t.QuotationTaskNum };
        });
        this.QTOptions = _.orderBy(dt.slice(0, 300), ["value"], ["desc"])
      }
    },
    ///报价申请编号下拉
    async QTRemoteMethod(query) {
      await this.getKvQuoteTask(query);
    },
    async on_query() {
      this.QuotationTaskNum = _.trim(this.QuotationTaskNum);
      this.$refs.CostCaclTable1.SetData([]);
      this.$refs.CostCaclTable2.SetData([]);
      this.$refs.CostCaclTable3.SetData([]);
      // if (this.QuotationTaskNum == "") {
      //   this.msgToasts("请输入报价申请编号！", "info");
      //   return;
      // }
      this.isBusy = true;
      let p = {
        QuotationTaskNum: this.QuotationTaskNum,
        CustName: "%" + this.CustName + "%",
        ItemId: this.ItemId,
        NameAlias: "%" + this.NameAlias + "%",
      }
      let _result = await QuotationTaskController.methods.getDetailDataBySql(p);
      if (!_.isNull(_result) && _result && _result.length > 0) {
        if (_result[0].length == 0)
          this.msgToasts("请检查报价申请是否处理完成！", "info");
        else
          this.$refs.CostCaclTable1.SetData(_.orderBy(_result[0], ["QuotationTaskNum", "LineNum"], ["desc", "asc"]));
      }

      this.isBusy = false;
    },
    current_changed(old, current) {
      if (current) {
        if (current.TransportCost && current.TransportCost != "")
          this.TransportCostJsonHis = JSON.parse(current.TransportCost)

        this.getDetailCost();
        this.getDetailVendPrice();
      }
    },
    //#region 制造商成本相关
    async getDetailCost(isLoading = true) {
      let current = this.$refs.CostCaclTable1.GetCurrentItem();
      if (!current) {
        return;
      }
      if (isLoading) {
        this.isBusy2 = true;
        this.$refs.CostCaclTable2.SetData([]);
      }
      let p = { QuotationTaskDetailId: { "=": current.id } };
      let _result = await CostItemsController.methods.getDataDetailCost(p);
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.each(_.orderBy(_result[0], ["id"], ["asc"]), (t) => {
          // t.TotalAllCost = t.TotalCost + t.TransportCost;
          this.transToContext(t);
        })
        this.$refs.CostCaclTable2.SetData(dt);
      }
      this.isBusy2 = false;
    },
    on_cell_button_click(data) {
      if (data.field.key == "TransportCost") {
        this.TransportCostJson = _.filter(this.TransportCostJsonHis, { AccountNum: data.item.AccountNum });
        this.dialogTableTitle = data.field.label + "(" + data.item.TransportCost + ")"
        this.dialogTableVisible = true;
      }
      else {
        this.DrawerTitle = "供应商：" + data.item.AccountName + "，制造成本：" + data.item.TotalCost;
        this.treeData1 = data.item.BomCostData;
        this.treeData2 = data.item.WrkCtrCostData;
        this.treeData3 = data.item.CostGroupData;
        this.total_cost = data.item.TotalCost;
        this.cur_product_qty = data.item.ProductQty;
        this.dataAreaId = _.find(this.$store.state.biz_data.baseData.CompanyInfo, { VenderAccountNum: data.item.AccountNum }).DataArea;
        this.isShowDrawer = true;
      }
    },
    transToContext(t, type) {
      if (type == 0) {
        t.BomCostData = JSON.stringify(t.BomCostData);
        t.CaclBomCostData = JSON.stringify(t.CaclBomCostData);
        t.CaclRouteData = JSON.stringify(t.CaclRouteData);
        t.CalcRsrcCostData = JSON.stringify(t.CalcRsrcCostData);
        t.CostGroupData = JSON.stringify(t.CostGroupData);
        t.WrkCtrCostData = JSON.stringify(t.WrkCtrCostData);
      }
      else {
        t.BomCostData = JSON.parse(t.BomCostData);
        t.CaclBomCostData = JSON.parse(t.CaclBomCostData);
        t.CaclRouteData = JSON.parse(t.CaclRouteData);
        t.CalcRsrcCostData = JSON.parse(t.CalcRsrcCostData);
        t.CostGroupData = JSON.parse(t.CostGroupData);
        t.WrkCtrCostData = JSON.parse(t.WrkCtrCostData);
      }
    },
    //#endregion
    //#region 供应商报价
    async getDetailVendPrice(isLoading = true) {
      let current = this.$refs.CostCaclTable1.GetCurrentItem();
      if (!current) {
        return;
      }
      if (isLoading) {
        this.isBusy3 = true;
        this.$refs.CostCaclTable3.SetData([]);
      }
      let p = { ItemId: { "=": current.ItemId } };
      let _result = await VendInitialQuoteController.methods.getData(p);
      if (_result && _result[0] && _result[0].Result.Data &&
        _result[0].Result.Data.length > 0 && _result[0].Result.Data[0]) {
        let dt = _.filter(_result[0].Result.Data[0], (t) => {
          if (!t.QuantityAmountTo) t.QuantityAmountTo = 9999999999;
          return current.BatchQty >= t.QuantityAmountFrom && current.BatchQty <= t.QuantityAmountTo;
        })
        this.$refs.CostCaclTable3.SetData(_.uniqBy(dt, "AccountNum"));
      }
      this.isBusy3 = false;
    },
    //#endregion

  },
}
</script>
<style >
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.bom .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  background-color: #1138e1b3;
  color: #fff;
}

.hb_table_costcaclsearch_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 105rem;
}

.bom .el-card__body,
.el-main {
  padding: 0px;
}

.bom .el-drawer__header {
  font-size: 1.1rem;
  color: black;
  padding-left: 0.5rem;
}

.el-message-box {
  width: 600px;
}</style>

